import React, { FunctionComponent } from 'react';

import { Box, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DateTime } from 'luxon';
import { v4 as uuid } from 'uuid';

import AnchorNavFirstOptionActive from '../Icons/CatalogAnchorNav/AnchorNavFirstOptionActive';
import AnchorNavSecondOptionActive from '../Icons/CatalogAnchorNav/AnchorNavSecondOptionActive';

interface CatalogAnchorNavProps {
  deliveryDates: string[];
  indexOfActiveCatalog: number;
  setIndexOfActiveCatalog(index: number): void;
}

const deliveryDateStyles = {
  display: 'flex',
  width: 'max-content',
  marginLeft: '0',
  padding: '0.6rem 0 0.1rem 0.6rem',
  flexDirection: 'column',
  userSelect: 'none',
  cursor: 'pointer',
  '.delivery-date:last-of-type': {
    marginTop: 'auto',
  },
};

const CatalogAnchorNav: FunctionComponent<CatalogAnchorNavProps> = ({
  deliveryDates,
  indexOfActiveCatalog,
  setIndexOfActiveCatalog,
}) => {
  const theme = useTheme();
  const { main } = theme.palette.primary;
  return (
    <React.Fragment>
      {deliveryDates?.length > 1 && (
        <Container
          disableGutters
          sx={{
            display: 'flex',
            flexDirection: 'row',
            paddingLeft: '0.5rem',
            width: '100%',
          }}
        >
          {indexOfActiveCatalog === 0 && (
            <AnchorNavFirstOptionActive
              activeOptionColor={main}
              greyFillColor={theme.palette.grey[400]}
            />
          )}
          {indexOfActiveCatalog === 1 && (
            <AnchorNavSecondOptionActive
              activeOptionColor={main}
              greyFillColor={theme.palette.grey[400]}
            />
          )}
          <Container disableGutters sx={deliveryDateStyles}>
            {deliveryDates.map((dDate, idx) => {
              const deliveryDate = DateTime.fromISO(dDate);
              const formattedDeliveryDateString = deliveryDate.toLocaleString({
                weekday: 'short',
                month: 'short',
                day: 'numeric',
              });
              return (
                <Box
                  key={formattedDeliveryDateString + uuid()}
                  className="delivery-date"
                  onClick={() => setIndexOfActiveCatalog(idx)}
                >
                  <Typography variant="overline" component="div">
                    Delivery Day {idx + 1}
                  </Typography>
                  <Typography variant="button" component="div" gutterBottom>
                    {formattedDeliveryDateString}
                  </Typography>
                </Box>
              );
            })}
          </Container>
        </Container>
      )}
    </React.Fragment>
  );
};

export default CatalogAnchorNav;
